import React, { useReducer } from 'react'
import ControlHubContext from './controlHubContext'
import ControlHubReducer from './controlHubReducer'
import { DirectAPICAll } from '../../common/components'
import { apiCall } from '../../common/api'
import { response } from '../common'
import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_FETCH_DATA,
    PLUGIN_USE_COUNT,
    LAST_UNPAID_INVOICE,
    LAST_PAID_INVOICE,
    GET_TABLE_DATA,
} from './controlHubTypes'

const ControlHubState = (props) => {
    const initialState = {
        token: '',
        search_fetch_data: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },

        plugin_use_count: { records: [], totalRecords: 0 },
        responseStatus: null,
        unpaid_payment: { records: [], totalRecords: 0 },
        paid_payment: { records: [], totalRecords: 0 },
        table_data: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
    }

    const [state, dispatch] = useReducer(ControlHubReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllPlugins = async (formData, fromVariable) => {
        try {
            const from = 'getAllPluginDetails'
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'controlhub'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_FETCH_DATA,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        config: res.data.data.responseData.pluginConfig.length
                            ? res.data.data.responseData.pluginConfig
                            : [],
                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const requestEmail = async (formData, fromVariable) => {
        try {
            const from = 'requestEmail'
            const [res] = await Promise.all([
                apiCall('post', 'requestEmail', formData, '', 'controlhub'),
            ])

            if (res.data.status === 'success') {
                resp.commonResponse(res.data, from)
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getPluginUseCount = async (formData, fromVariable) => {
        try {
            const from = 'getPluginUseCount'
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'controlhub'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: PLUGIN_USE_COUNT,
                    payload: {
                        records: res.data.data.responseData?.records?.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData?.totalRecords,
                        pluginDetails: res.data.data.responseData?.pluginDetails
                            ?.length
                            ? res.data.data.responseData.pluginDetails
                            : [],
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            console.log('Mainerror', err)
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getPendingPayments = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getPendingPayments',
                    formData,
                    '',
                    'controlhub'
                ),
            ])

            if (res.data.status === 'success') {
                if (from === 'lastMonth') {
                    dispatch({
                        type: LAST_PAID_INVOICE,
                        payload: {
                            records: res.data.data.responseData
                                ? res.data.data.responseData
                                : [],
                            totalRecords: res.data.data?.totalRecords,
                            from,
                        },
                    })
                } else {
                    dispatch({
                        type: LAST_UNPAID_INVOICE,
                        payload: {
                            records: res.data.data.responseData
                                ? res.data.data.responseData
                                : [],
                            totalRecords: res.data.data?.totalRecords,
                            from,
                        },
                    })
                }
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const payCartStripe = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'makePayment', formData, '', 'controlhub'),
            ])
            resp.commonResponse(res.data, 'payment')
        } catch (err) {
            resp.commonErrorResponse('payment')
        }
    }

    const getTableDataDynamic = async (formData, fromVariable) => {
        try {
            const from = 'getTableData'
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'controlhub'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_TABLE_DATA,
                    payload: {
                        records:
                            res.data.data.responseData.records &&
                            res.data.data.responseData.records.length
                                ? res.data.data.responseData.records
                                : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <ControlHubContext.Provider
            value={{
                responseStatus: state.responseStatus,
                search_fetch_data: state.search_fetch_data,
                plugin_use_count: state.plugin_use_count,
                unpaid_payment: state.unpaid_payment,
                paid_payment: state.paid_payment,
                table_data: state.table_data,
                getTableDataDynamic,
                getAllPlugins,
                clearResponse,
                requestEmail,
                getPluginUseCount,
                getPendingPayments,
                payCartStripe,
            }}
        >
            {props.children}
        </ControlHubContext.Provider>
    )
}

export default ControlHubState
